const Password = (val) => {
    const valid = val.length >= 8;

    return [
        valid,
        valid ? null : 'Your password must be at least 8 characters long',
    ]
}

export default Password;